import {
  FETCH_LEAVE_REQUESTS_REQUEST,
  FETCH_LEAVE_REQUESTS_SUCCESS,
  FETCH_LEAVE_REQUESTS_FAIL,
} from "../../constants/Leave/LeaveRequestConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const LeaveRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEAVE_REQUESTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LEAVE_REQUESTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_LEAVE_REQUESTS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default LeaveRequestReducer;